module.exports = __webpack_public_path__ + "static/media/shop_type_4.b81fe99e.png";